import React, { useContext } from "react";
import { contentTypes } from "./../data";
import LanguageContext from "./../contexts/languageContext.js";

import TextQuestion from "./TextQuestion";
import SelectOneQuestion from "./SelectOneQuestion";
import {
  fieldReadyToSubmit,
  fieldWasOnceReadyToSubmit,
} from "./../sharedLogic.js";

export default function ContentParser({ content, formState, handler }) {
  const { language } = useContext(LanguageContext);

  const contentType = content.type;

  if (contentType === contentTypes.sectionHeader) {
    return (
      <h2 className="mb-3 mt-4 text-center">
        {content.config.label[language]}
      </h2>
    );
  }

  if (contentType === contentTypes.selectOneQuestion) {
    const { label, options, id } = content.config;
    const readyToSubmit = fieldReadyToSubmit(content.config, formState);
    const needsAttention =
      !readyToSubmit && fieldWasOnceReadyToSubmit(content.config, formState);
    return (
      <SelectOneQuestion
        readyToSubmit={readyToSubmit}
        needsAttention={needsAttention}
        label={label}
        options={options}
        id={id}
        handler={handler}
        formState={formState}
      />
    );
  }

  if (contentType === contentTypes.textQuestion) {
    const { label, options, id } = content.config;

    return (
      <TextQuestion
        label={label}
        options={options}
        mandatory={
          content.config.hasOwnProperty("mandatory") &&
          content.config.mandatory === true
        }
        id={id}
        handler={handler}
        formState={formState}
      />
    );
  }

  return <div>content type not detected</div>;
}
